import { render, staticRenderFns } from "./PublicActivityListScreen.vue?vue&type=template&id=288c4a77&"
import script from "./PublicActivityListScreen.vue?vue&type=script&lang=js&"
export * from "./PublicActivityListScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports